import SocialLinks from "../components/SocialLinks";

export default function About() {
  return (
    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 md:py-24" data-testid="about-page">
      <div className="grid grid-cols-12 gap-10">
        <div className="col-span-12 lg:col-span-5 reveal">
          <div className="overflow-hidden bg-[var(--ink-2)]">
            <img
              src="https://customer-assets.emergentagent.com/job_gallery-works/artifacts/uvj75i3a_334100824_670736984809564_4424695675652569041_n%20copy.jpg"
              alt="Sergio Mancinelli — portrait"
              className="w-full h-auto block"
              data-testid="about-portrait"
            />
          </div>
          <div className="mt-4 text-xs uppercase tracking-[0.3em] text-[var(--muted)]">Sergio Mancinelli</div>
        </div>

        <div className="col-span-12 lg:col-span-7 reveal" style={{ transitionDelay: "150ms" }}>
          <div className="text-xs uppercase tracking-[0.4em] text-[var(--ember)] mb-6">About</div>
          <h1 className="font-serif text-5xl md:text-7xl leading-[0.85] text-[var(--paper)] italic">
            About <em className="text-[var(--ember)]">me</em>.
          </h1>
          <div className="mt-10 space-y-6 text-[var(--bone)] text-lg leading-relaxed max-w-2xl">
            <p>Born in Naples, Italy, '95.</p>
            <p>
              I'm an art director and visual developer working in the animation film industry. At the
              moment, I'm freelancing with Warner Animation Group, contributing to feature projects
              and visual development.
            </p>
            <p>
              I studied comics and digital painting at the Italian School of Comix in Naples. I then
              worked for two years as a background and layout artist on Netflix's <em className="italic text-[var(--paper)]">Klaus</em>,
              produced by The SPA Studios in Madrid, where I also contributed to various stages of
              visual development. More recently, I was part of the layout team for the Academy
              Award-winning short <em className="italic text-[var(--paper)]">The Boy, the Mole, the Fox and the Horse</em>, produced for Apple TV.
            </p>
            <p>
              I've also worked as a Visual Development artist on the upcoming animated adaptation of
              <em className="italic text-[var(--paper)]"> Animal Farm</em> at Cinesite, and have collaborated with studios including Warner Bros.
              Animation, Illumination MacGuff, Spin Master, The Line, DreamWorks TV, and Disney TV.
            </p>
            <p>
              Alongside client work, I'm actively developing personal projects exploring new visual
              languages and stories I want to tell.
            </p>
          </div>

          <div className="mt-10 space-y-3">
            <div className="text-xs uppercase tracking-[0.3em] text-[var(--muted)]">Social</div>
            <SocialLinks/>
          </div>

          <div className="mt-14 grid grid-cols-2 gap-6 border-t hairline pt-8">
            <div>
              <div className="text-xs uppercase tracking-[0.3em] text-[var(--muted)] mb-2">Disciplines</div>
              <div className="font-serif text-xl text-[var(--paper)] leading-snug">Art Direction · Vis Dev · Color Keys · Background Painting · Layout</div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.3em] text-[var(--muted)] mb-2">Selected Clients</div>
              <div className="font-serif text-xl text-[var(--paper)] leading-snug">Warner Bros., DreamWorks, Disney TV, SPA Studios, Cinesite, The Line, Illumination MacGuff, Spin Master, Apple TV, BBC, Netflix</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
